// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const zigzagoon: PokeData = {
  "id": 263,
  "name": "zigzagoon",
  "height": 4,
  "weight": 175,
  "base_experience": 56,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "sand-attack",
    "headbutt",
    "tackle",
    "take-down",
    "double-edge",
    "tail-whip",
    "pin-missile",
    "growl",
    "rest",
    "flail",
    "belly-drum",
    "mud-sport",
    "odor-sleuth",
    "covet",
    "fling",
    "bestow",
    "baby-doll-eyes"
  ],
  "moves": [
    "headbutt",
    "tackle",
    "pin-missile",
    "growl",
    "scratch",
    "purification",
    "quick-attack",
    "scary-face",
    "protect",
    "tri-attack",
    "refresh",
    "supersonic",
    "leer"
  ],
  "evolution_chain": {
    "id": 134,
    "item": null,
    "species": [
      {
        "name": "zigzagoon",
        "order": 288,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "linoone",
        "order": 289,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 263,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "obstagoon",
        "order": 862,
        "types": [
          PokeType.DARK,
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 264,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 35,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "night",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 39.5,
    "speed": 60,
    "ability_power": 30
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
